import { isUndefinedOrNullOrEmptyString } from "@/module/Validation/rules/isUndefinedOrNullOrEmptyString";

const validate = (value: any): boolean => {
  if (isUndefinedOrNullOrEmptyString(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every((val) => validate(val));
  }

  value = String(value);
  const regexp = new RegExp(/.*\d.*/);

  return regexp.test(value);
};

export { validate };

export default {
  validate,
};
